import tradeInAPI from '../../lib/api/tradeIn'

export default {
  async getTradeInList ({ commit }, { page, search }) {
    try {
      return await tradeInAPI.getTradeInListAPI(page, search)
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getTradeInDetail ({ commit }, upgradeId) {
    try {
      return await tradeInAPI.getTradeInDetailAPI(upgradeId)
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async approveDiagnostic ({ commit }, upgradeId) {
    try {
      return await tradeInAPI.approveDiagnosticAPI(upgradeId)
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async markTradeInAsReceived ({ commit }, upgradeId) {
    try {
      return await tradeInAPI.markAsReceivedAPI(upgradeId)
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async updateTradeInProposal ({ commit }, { upgradeId, amount }) {
    try {
      return await tradeInAPI.updateProposalAPI(upgradeId, amount)
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async closeTradeIn ({ commit }, upgradeId) {
    try {
      return await tradeInAPI.closeTradeInAPI(upgradeId)
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
